// exports.saveDocument = function saveDocument() {
  
//     // save the document as PDF
//     TXTextControl.saveDocument(TXTextControl.StreamType.AdobePDF, function (e) {
//     bDocument = e.data;
//     // create temporary link to download document
//     var element = document.createElement('a');
//     element.setAttribute('href', 'data:application/octet-stream;base64,' + bDocument);
//     element.setAttribute('download', "results.pdf");
  
//     element.style.display = 'none';
//     document.body.appendChild(element);
  
//     // simulate click
//     element.click();
  
//     // remove the link
//     document.body.removeChild(element);
//     });
    
//   }



// API FUNCTIONS
function loadDocument(document) {
  TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat, document);
}

function saveDocument() {
  return new Promise(resolve => {
    TXTextControl.saveDocument(TXTextControl.streamType.InternalUnicodeFormat, function (e) {
      resolve(e.data);
    });
  });
}


function saveDocument_THEME() {
  return new Promise(resolve => {
    TXTextControl.saveDocument(TXTextControl.streamType.InternalUnicodeFormat, function (e) {
      resolve(e.data);
    });
  });
}


function loadData(JsonData) {
  TXTextControl.addEventListener("textControlLoaded", function () {
    TXTextControl.loadJsonData(JSON.stringify(JsonData));
  });
}

function loadData2(JsonData) {
  TXTextControl.addEventListener("textControlLoaded", function () {
    TXTextControl.loadJsonData(JSON.stringify(JsonData));
  });
}

function loadTemplate(filename) {
  // TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat, filename);
  TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, filename);
}


function loadTemplate_WWW(ConnectionID, document) {
  // TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat, filename);
  TXTextControl.loadDocument(TXTextControl.streamType.WordprocessingML, document);
}


function loadDocument_SIMPLE(data) {
  // TXTextControl.loadDocument(TXTextControl.streamType.InternalUnicodeFormat, filename);
  TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML, data);
}
function loadDocument_TEMPLATE(data) {
  TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML, data);
}
function loadDocument_THEME(data) {
  TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML, data);
}

function loadDocument_TEMPLATE_Ext(data) {
  TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML, data);
}

function loadDocument_DocumentCreated(data) {
  TXTextControl.loadDocument(TXTextControl.StreamType.WordprocessingML, data);
}

function saveTemplate(data, filename) {
  return new Promise(resolve => {
    TXTextControl.saveDocument(TXTextControl.streamType.InternalUnicodeFormat, function (e) {
      resolve(e.data);
    });
  });
}